"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _templateObject, _templateObject2;
const _excluded = ["center", "size", "type", "className"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var spinType = /*#__PURE__*/function (spinType) {
  spinType["primary"] = "primary";
  spinType["success"] = "success";
  spinType["error"] = "error";
  spinType["warning"] = "warning";
  spinType["ghost"] = "ghost";
  spinType["white"] = "white";
  spinType["link"] = "link";
  return spinType;
}(spinType || {});
const defaultProps = {
  size: 40,
  type: spinType.primary,
  className: ''
};
function SpinComponent(props) {
  const _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
    {
      center,
      size,
      type,
      className
    } = _defaultProps$props,
    restOfProps = _objectWithoutProperties(_defaultProps$props, _excluded);
  return /*#__PURE__*/_react.default.createElement(Wrapper, _extends({
    center: center,
    "data-testid": "loading-spin-testid",
    className: className
  }, restOfProps), /*#__PURE__*/_react.default.createElement(Spin, {
    size: size,
    type: type
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "double-bounce1"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "double-bounce2"
  })));
}
const Wrapper = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), _ref => {
  let {
    center
  } = _ref;
  return center && "\n      width: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n  ";
});
const Spin = _styled.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: ", "px;\n  height: ", "px;\n  position: relative;\n\n  .double-bounce1,\n  .double-bounce2 {\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    opacity: 0.6;\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    background-color: ", ";\n\n    -webkit-animation: sk-bounce 2s infinite ease-in-out;\n    animation: sk-bounce 2s infinite ease-in-out;\n  }\n\n  .double-bounce2 {\n    -webkit-animation-delay: -1s;\n    animation-delay: -1s;\n  }\n\n  @-webkit-keyframes sk-bounce {\n    0%,\n    100% {\n      -webkit-transform: scale(0);\n    }\n    50% {\n      -webkit-transform: scale(1);\n    }\n  }\n\n  @keyframes sk-bounce {\n    0%,\n    100% {\n      transform: scale(0);\n      -webkit-transform: scale(0);\n    }\n    50% {\n      transform: scale(1);\n      -webkit-transform: scale(1);\n    }\n  }\n"])), _ref2 => {
  let {
    size
  } = _ref2;
  return size;
}, _ref3 => {
  let {
    size
  } = _ref3;
  return size;
}, _ref4 => {
  var _theme$colors$MAIN;
  let {
    type,
    theme
  } = _ref4;
  if (type === spinType.ghost) return theme.colors.NEUTRAL.SELECTED;
  if (type === spinType.white) return theme.colors.FONT.TITLE;
  if (type === spinType.link) return theme.colors.MAIN.PRIMARY;
  return (_theme$colors$MAIN = theme.colors.MAIN) === null || _theme$colors$MAIN === void 0 ? void 0 : _theme$colors$MAIN[String(type).toUpperCase()];
});
var _default = exports.default = SpinComponent;